export enum ResourceSurveyTemplateCategoryStatuses {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}
